import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { observer } from 'mobx-react';

import routes from 'core/routes';
import { Products } from 'core/constants';
import { useStore } from 'utils/hooks/store';

import { SecureRouteProps } from './types';

const SecureRoute: React.FC<SecureRouteProps> = ({
  children,
  isAuthorized,
  redirectComponent: UnauthorizedComponent,
  onUnauthorizedRedirectProducts,
  redirectTo,
}) => {
  const { session } = useStore();
  const location = useLocation();

  // Extract only serializable properties from location to avoid DataCloneError
  // when passing to Navigate's state (history.replaceState requires serializable data)
  const serializableLocation = {
    pathname: location.pathname,
    search: location.search,
    hash: location.hash,
  };

  const hasAccess = isAuthorized(session);

  if (hasAccess) {
    return <>{children}</>;
  }

  if (redirectTo) {
    return <Navigate to={redirectTo} state={{ from: serializableLocation }} replace />;
  }

  if (onUnauthorizedRedirectProducts) {
    if (session.user?.licenses.protectorAlarms) {
      return <Navigate to={routes.dashboard.alarms.activityMap} state={{ from: serializableLocation }} replace />;
    }
    window.location.assign(Products.admin);
    return null;
  }

  if (UnauthorizedComponent) {
    return <UnauthorizedComponent />;
  }

  return null;
};

export default observer(SecureRoute);
